// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBo1qB6nTkZ39bCJtIZnRRe6RkuiGFD27k",
  authDomain: "genai-krishitech-new.firebaseapp.com",
  projectId: "genai-krishitech-new",
  storageBucket: "genai-krishitech-new.firebasestorage.app",
  messagingSenderId: "1073045656553",
  appId: "1:1073045656553:web:72312729e636cb5b403178",
  measurementId: "G-SZBEBY6VRG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
